import { apiRequest } from './api.js';
import { getSession, restoreSession } from './auth.js';

const CHAVE = 'torre:app';
const REFRESH = 'torre:app-refresh';
const PUSH = 'torre:app-push';
const INSTALACAO = 'torre:app-id';
const DEVICE = 'torre:app-device';

function ler(chave) {
  try {
    return localStorage.getItem(chave) || '';
  } catch {
    return '';
  }
}

function gravar(chave, valor) {
  try {
    if (valor) localStorage.setItem(chave, valor);
    else localStorage.removeItem(chave);
  } catch {
    /* o navegador pode bloquear o armazenamento */
  }
}

function lerShell() {
  const local = ler(CHAVE);
  if (local) return local;
  try {
    return sessionStorage.getItem(CHAVE) || '';
  } catch {
    return '';
  }
}

export function shellDoApp() {
  const bruto = lerShell();
  if (!bruto) return null;
  try {
    const shell = JSON.parse(bruto);
    if (shell?.plataforma !== 'ios' && shell?.plataforma !== 'android') return null;
    return shell;
  } catch {
    return null;
  }
}

export function appDePrevia() {
  return shellDoApp()?.instalacaoId === 'preview';
}

export function aparelhoLocal() {
  const shell = shellDoApp();
  if (!shell || shell.instalacaoId === 'preview') return null;
  return {
    id: ler(DEVICE),
    nome: shell.nome || (shell.plataforma === 'android' ? 'Android' : 'iPhone'),
    plataforma: shell.plataforma,
  };
}

async function chamar(path, body, method = 'POST') {
  const data = await apiRequest(path, {
    method,
    body: method === 'GET' ? undefined : JSON.stringify(body || {}),
  });
  return data?.data || {};
}

export async function registrarAparelho() {
  const shell = shellDoApp();
  if (!shell || !getSession() || appDePrevia()) return null;
  const instalacaoId = shell.instalacaoId || ler(INSTALACAO) || crypto.randomUUID();
  gravar(INSTALACAO, instalacaoId);
  const data = await chamar('/integrations/apps/dispositivo', {
    plataforma: shell.plataforma,
    instalacaoId,
    nome: shell.nome || (shell.plataforma === 'android' ? 'Android' : 'iPhone'),
    modelo: shell.modelo || '',
    pushToken: ler(PUSH),
    appVersao: shell.appVersao || '',
  });
  if (data.refreshToken) gravar(REFRESH, data.refreshToken);
  if (data.instalacaoId) gravar(INSTALACAO, data.instalacaoId);
  if (data.dispositivo?.id) gravar(DEVICE, data.dispositivo.id);
  return data;
}

function pedirNotificacao() {
  try {
    window.webkit?.messageHandlers?.torre?.postMessage({ acao: 'notificacao' });
  } catch {
    /* fora do iPhone */
  }
  try {
    window.TorreNativo?.pedirNotificacao?.();
  } catch {
    /* fora do Android */
  }
  if (typeof Notification === 'undefined' || !Notification.requestPermission) {
    return Promise.resolve('unsupported');
  }
  return Notification.requestPermission().catch(() => 'denied');
}

export async function prepararApp() {
  if (!shellDoApp() || appDePrevia()) return;
  if (!getSession() && ler(REFRESH)) {
    try {
      const data = await chamar('/auth/app/retomar', { refreshToken: ler(REFRESH) });
      if (data.refreshToken) gravar(REFRESH, data.refreshToken);
      await restoreSession();
    } catch {
      gravar(REFRESH, '');
    }
  }
  if (!getSession()) return;
  try {
    await registrarAparelho();
  } catch {
    /* o cadastro tenta de novo na próxima abertura */
  }
}

export async function esquecerAparelho() {
  if (!shellDoApp()) return;
  const id = ler(DEVICE);
  gravar(REFRESH, '');
  gravar(PUSH, '');
  gravar(DEVICE, '');
  if (!id) return;
  try {
    await chamar('/integrations/apps/dispositivo', { id }, 'DELETE');
  } catch {
    /* sem sessão o aparelho deixa de receber quando o token expira */
  }
}

function definirPush(token) {
  gravar(PUSH, String(token || '').slice(0, 400));
  if (getSession()) registrarAparelho().catch(() => {});
}

function mostrarNoCelular(aviso) {
  const titulo = String(aviso?.titulo || 'Torre de Controle').slice(0, 80);
  const corpo = String(aviso?.corpo || 'Nova venda').slice(0, 140);
  try {
    if (!window.webkit?.messageHandlers?.torre) return false;
    window.webkit.messageHandlers.torre.postMessage({ acao: 'aviso', titulo, corpo });
    return true;
  } catch {
    return false;
  }
}

window.torreApp = {
  definirPush,
  pedirNotificacao,
  mostrarNoCelular,
  plataforma(valor) {
    const plataforma = valor === 'android' ? 'android' : 'ios';
    const atual = shellDoApp() || {};
    gravar(CHAVE, JSON.stringify({ ...atual, plataforma }));
  },
};
